'use client'

import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area'
import { tv } from '../utils'

const scrollAreaStyles = tv({
	base: 'relative overflow-hidden',
})

const scrollBarStyles = tv({
	base: 'flex touch-none select-none transition-colors',
	variants: {
		orientation: {
			vertical: 'h-full w-2.5 border-l border-l-transparent p-px',
			horizontal: 'h-2.5 flex-col border-t border-t-transparent p-px',
		},
	},
	defaultVariants: {
		orientation: 'vertical',
	},
})

const scrollThumbStyles = tv({
	base: 'relative bg-border',
	variants: {
		orientation: {
			vertical: 'flex-1',
			horizontal: '',
		},
	},
	defaultVariants: {
		orientation: 'vertical',
	},
})

type ScrollAreaProps = React.ComponentProps<typeof ScrollAreaPrimitive.Root> & {
	hideScrollbar?: boolean
}

const ScrollArea = ({ className, children, hideScrollbar, ...props }: ScrollAreaProps) => (
	<ScrollAreaPrimitive.Root className={scrollAreaStyles({ class: className })} {...props}>
		<ScrollAreaPrimitive.Viewport className='h-full w-full rounded-[inherit]'>
			{children}
		</ScrollAreaPrimitive.Viewport>
		{!hideScrollbar && <ScrollBar />}
		<ScrollAreaPrimitive.Corner />
	</ScrollAreaPrimitive.Root>
)

type ScrollBarProps = React.ComponentProps<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>

const ScrollBar = ({ className, orientation = 'vertical', ...props }: ScrollBarProps) => (
	<ScrollAreaPrimitive.ScrollAreaScrollbar
		orientation={orientation}
		className={scrollBarStyles({ orientation, class: className })}
		{...props}
	>
		<ScrollAreaPrimitive.ScrollAreaThumb className={scrollThumbStyles({ orientation })} />
	</ScrollAreaPrimitive.ScrollAreaScrollbar>
)

export { ScrollArea, ScrollBar }
